import { render, staticRenderFns } from "./DeliveryAddresses.vue?vue&type=template&id=aff07434&scoped=true"
import script from "./DeliveryAddresses.vue?vue&type=script&lang=js"
export * from "./DeliveryAddresses.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAddresses.vue?vue&type=style&index=0&id=aff07434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff07434",
  null
  
)

export default component.exports